import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateOfferMutation = createMutationHook(OffersApiClient.updateOffer, {
  mutationKey: ['updateOffer'],
})
